import React, { Component } from 'react';
import connect from 'react-redux/es/connect/connect';

class Header extends Component {
  render() {
    const { loading, refreshing, stop, config } = this.props;
    let { stopText } = config

    return (!stop) ? null : (
      <div className={`halte-header ${(loading && !refreshing) ? 'halte-header--loading' : ''}`}>
        <div className="container container--center container--margin">
          <h1>
            {stopText}
            <span className="halte-header__sub-title">{stop.town}, {stop.name}</span>
          </h1>
        </div>
        <hr/>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      stop: state.stop.data,
      loading: state.stop.loading,
      refreshing: state.stop.refreshing
    };
  },
  {}
)(Header);



// WEBPACK FOOTER //
// ./src/components/Haltes/Header.js